import React, { useEffect, useState, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { GET, httpOk } from 'helpers/api'
import { FilterBar, getDateRange, mln, TA_CSS } from './tovarShared'

const LEVEL = {
	urgent: { bg: '#fef2f2', color: '#b91c1c', key: 'lv_urgent' },
	soon: { bg: '#fffbeb', color: '#b45309', key: 'lv_soon' },
	ok: { bg: '#f0fdf4', color: '#15803d', key: 'lv_ok' },
}

function Reorder() {
	const { t } = useTranslation()
	const [data, setData] = useState({ departments: {} })
	const [quick, setQuick] = useState('month')
	const [range, setRange] = useState(getDateRange('month'))
	const [custom, setCustom] = useState({ start: null, end: null })

	const load = useCallback(async (r) => {
		const res = await GET('/analytics/reorder', { start_date: r.start, end_date: r.end }, { loader: true })
		if (httpOk(res)) setData(res.data)
	}, [])
	useEffect(() => { load(range) }, [range, load])

	function onQuick(id) { setQuick(id); setCustom({ start: null, end: null }); setRange(getDateRange(id)) }
	function onCustom(s, e) {
		setCustom({ start: s, end: e })
		if (s && e) { setQuick(''); const f = d => d.toISOString().slice(0, 10); setRange({ start: f(s), end: f(e) }) }
	}

	const depts = Object.entries(data.departments || {})
	return (
		<>
			<style>{TA_CSS}</style>
			<div className="ta">
				<div className="ta-head">
					<div>
						<h4>{t('reorder_title')}</h4>
						<div className="ta-hint">{t('reorder_hint')}</div>
					</div>
					<FilterBar quick={quick} custom={custom} onQuick={onQuick} onCustom={onCustom} t={t} />
				</div>

				{depts.map(([tid, d]) => {
					const need = d.items.filter(x => x.level !== 'ok')
					return (
						<div className="ta-block" key={tid}>
							<div className="ta-block-h">
								<i className="uil-box me-1" />{d.name}
								<span className="ta-pill" style={{ background: need.length ? '#fef2f2' : '#f0fdf4', color: need.length ? '#b91c1c' : '#15803d', marginLeft: 8 }}>
									{need.length ? `${need.length} ${t('need_reorder')}` : t('stock_ok')}
								</span>
							</div>
							<div className="ta-scroll">
								<table className="ta-tbl">
									<thead>
										<tr>
											<th>{t('name')}</th>
											<th className="ta-num">{t('sold_period')}</th>
											<th className="ta-num">{t('in_stock')}</th>
											<th className="ta-num">{t('days_left')}</th>
											<th className="ta-num">{t('reorder_qty')}</th>
											<th className="text-center">{t('status')}</th>
										</tr>
									</thead>
									<tbody>
										{d.items.slice(0, 40).map(r => {
											const lv = LEVEL[r.level]
											return (
												<tr key={r.id} style={{ background: r.level === 'urgent' ? '#fef2f206' : undefined }}>
													<td className="fw-semibold">{r.name}</td>
													<td className="ta-num">{mln(r.sold_qty)}</td>
													<td className="ta-num">{mln(r.stock_qty)}</td>
													<td className="ta-num fw-bold" style={{ color: lv.color }}>{r.days_left >= 9999 ? '∞' : r.days_left + ' ' + t('day')}</td>
													<td className="ta-num fw-bold">{r.reorder_qty > 0 ? '+' + mln(r.reorder_qty) : '—'}</td>
													<td className="text-center"><span className="ta-pill" style={{ background: lv.bg, color: lv.color }}>{t(lv.key)}</span></td>
												</tr>
											)
										})}
										{d.items.length === 0 && <tr><td colSpan={6} className="ta-empty">{t('no_data')}</td></tr>}
									</tbody>
								</table>
							</div>
						</div>
					)
				})}
				{depts.length === 0 && <div className="ta-block"><div className="ta-empty">{t('no_data')}</div></div>}
			</div>
		</>
	)
}

export default Reorder
